export class SearchSubticketTemplates {
  public SubticketIds: number[];
  searchFilter: unknown;
}
